import { IClassroomResource } from "../../classrooms";
import { PeriodParam } from "../../types";
import { IUserResource } from "../../users";
import {
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    createApiQueryHook,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { OneOrManyFilter, RelationalValue, mapRelationalValue } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { IWorkList, WorkStatus } from "../../works";

export interface IWorkListQueryParameters extends IPaginateable, IOrderable<"createdAt"> {
    filters?: {
        learner?: RelationalValue<IUserResource>;
        classroom?: RelationalValue<IClassroomResource>;
        status?: OneOrManyFilter<WorkStatus>;
        createdAtBefore?: {
            date: string;
            param: PeriodParam.BEFORE | PeriodParam.STRICTLY_BEFORE;
        };
        createdAtAfter?: {
            date: string;
            param: PeriodParam.AFTER | PeriodParam.STRICTLY_AFTER;
        };
        intervalStart?: string;
        intervalEnd?: string;
    };
}

export type IWorkListQueryResult = IWorkList;

const mapFilters = (filters: IWorkListQueryParameters["filters"]) => {
    const { learner, classroom, status, createdAtBefore, createdAtAfter, intervalStart, intervalEnd } = filters || {};

    return {
        "topic.learner.uuid": learner ? mapRelationalValue(learner) : undefined,
        "topic.classroom.uuid": classroom ? mapRelationalValue(classroom) : undefined,
        status,
        [`createdAt[${createdAtBefore?.param ?? PeriodParam.BEFORE}]`]: createdAtBefore?.date,
        [`createdAt[${createdAtAfter?.param ?? PeriodParam.AFTER}]`]: createdAtAfter?.date,
        "interval[start]": intervalStart,
        "interval[end]": intervalEnd,
    };
};

export const workListQuery: IApiQueryFunction<IWorkListQueryParameters> = ({ filters, pagination, order }) => {
    return {
        method: "GET",
        url: `/works${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useWorkListQuery = createApiQueryHook<IWorkListQueryParameters, IWorkListQueryResult>(workListQuery);
